
export const urbanArtworks = [
  {
    id: 1,
    image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/21acdd4a127789415721bd35d26c8e89.jpeg",
    title: "I Love You",
    category: "Escultura",
    description: "Escultura urbana con mensaje de amor, fusionando arte callejero y expresión emocional en una pieza única.",
    year: "2024",
    technique: "Escultura Mixta"
  },
  {
    id: 2,
    image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/ea8aebbf0cd920e837aec61a610e690c.jpeg",
    title: "Escultura Encapuchada",
    category: "Escultura",
    description: "Figura encapuchada en tonos oscuros que evoca misterio y reflexión sobre la identidad urbana.",
    year: "2024",
    technique: "Escultura en Resina"
  },
  {
    id: 3,
    image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/27bfe4bb0588402e544d7175eab08a42.jpeg",
    title: "Hope",
    category: "Toy Art",
    description: "Personaje metálico con máscara de gas sosteniendo una bandera de paz sobre un globo terráqueo. Un mensaje de esperanza en tiempos difíciles.",
    year: "2023",
    technique: "Escultura Metálica"
  },
  {
    id: 4,
    image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/e006de72405d03e90d6bc418f9eee144.jpeg",
    title: "Tiburones",
    category: "Pintura",
    description: "Obra vibrante con fondo azul intenso y siluetas de tiburones en movimiento, capturando la energía del océano.",
    year: "2023",
    technique: "Acrílico sobre Lienzo"
  },
  {
    id: 5,
    image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/1ca496c314dcbde0814615d576a7ebfc.jpeg",
    title: "Street Art",
    category: "Stencil",
    description: "Arte urbano estilo stencil en blanco y negro con crítica social, explorando el consumismo y la inocencia perdida.",
    year: "2023",
    technique: "Stencil & Spray"
  },
  {
    id: 6,
    image: "https://static.readdy.ai/image/8671031128391c697a2e9f09b82e3420/52ffaef7b746ec33c43c1f0fa938c695.jpeg",
    title: "Busto Clásico",
    category: "Escultura",
    description: "Reinterpretación contemporánea de la escultura clásica, fusionando lo antiguo con la estética urbana moderna.",
    year: "2024",
    technique: "Escultura en Yeso"
  }
];

export const urbanCategories = [
  "Todos",
  "Escultura",
  "Pintura",
  "Stencil",
  "Toy Art"
];
